<div class="get-directions {{language}}">
    <div class="row">
      <div class="col-12 col-md-6">
        <div class="dealer-info-pane js-dealer-info-pane" tabindex="-1">
  
          <form [formGroup]="directionsForm">
            <!-- "USE MY ADDRESS" CHECKBOX -->
            <div class="gb-checkbox" [hidden]="hideCheckbox">
                  <input  id="directions" type="checkbox" class="gb-checkbox" [trackLink]="'GetDirections:UseMyAddress'"
                          [trackDelay]="'true'" [trackType]="'o'" [prop10]="'getDirections:checkbox:use my address'"
                          (change)="togglePopulateStartingAddress()" [checked]="addressCheckbox">
                  <label for="directions" [translate]="'directions_useMyAddress_label'"></label>
            </div>
  
            <!-- DIRECTIONS FROM -->
              <div class="mb-5" [trackLink]="'GetDirections:StartingAddress'" [trackDelay]="'true'" [trackType]="'o'" [prop10]="'getDirections:textbox:starting address'">
                <ox-text-input (change)="touchedStartingAddress()" [id]="'startingAddress'" [inputName]="'startingAddress'" [classes]="'form-control'"
                               [required]="true" [pattern]="addressPattern" [maxLength]="addressMaxLength" [placeHolderText]="''"
                               [ariaLabel]="'startingAddress'" [label]="'directions_startingInput_label'" [iconLocation]="true"
                               [formGroupInput]="directionsForm" [formControlNameInput]="'startingAddress'">
                </ox-text-input>
              </div>
  
            <!-- DIRECTIONS TO -->
              <div class="mb-5" [trackLink]="'GetDirections:DealerAddress'" [trackDelay]="'true'" [trackType]="'o'" [prop10]="'getDirections:textbox:dealer address'">
                <ox-text-input class="mb-5" [id]="'endingAddress'" [inputName]="'dealerAddress'" [classes]="'form-control'"
                               [required]="true" [pattern]="addressPattern" [maxLength]="addressMaxLength" [placeHolderText]="''"
                               [ariaLabel]="'endingAddress'" [label]="'directions_endingInput_label'" [iconLocation]="true"
                               [formGroupInput]="directionsForm" [formControlNameInput]="'dealerAddress'">
                </ox-text-input>
              </div>

          </form>
  
          <!-- GET DIRECTIONS BUTTON -->
          <div [trackLink]="'Dealer:GetDirections'" [trackDelay]="'true'" [trackType]="'o'" [prop10]="'dealer:button:get directions'">
            <button class="gb-primary-button {{language}} col-12 col-lg-4"
                    [ngClass]="{'disabled': directionsForm.invalid}"
                    [disabled]="directionsForm.invalid"
                    (click)="getDirections()"
                    aria-atomic="true"
                    aria-live="assertive">
                <span [translate]="'directions_getDirectionsBtn'"></span>&nbsp;
                <span aria-hidden="true" class="icon-ui-directions"></span>
            </button>
          </div>
  
          <!-- GOOGLE MAPS LINK -->
          <div class="margin-top-medium gb-body1">
            <a class="'no-href"
               (click)="openGoogleMaps()"
               aria-haspopup="dialog"
               aria-expanded="false"
               attr.aria-label="{{'aoda_open_new_window_aria_label' | translate}}" >
              <span role="presentation" class="icon-ui-newwindow"></span>&nbsp;
              <span [translate]="'aoda_dealer_directions_open_google_maps'"></span>
            </a>
          </div>
  
          <div class="margin-top-medium" [hidden]="!showDirectionsText">
            <div class="gb-headline3" role="heading" aria-level="3" [translate]="'locateDealer_directions_panelHeader'" [translateParams]="{currentDealer: dealer}"></div>
            <div class="js-dealer-directions-card gb-body1"></div>
            <div class="margin-top-large mb-0">
              <button class="gb-primary-button col-12 col-lg-3"
                      (click)="printDirections()"
                      [trackLink]="'Dealer:PrintDirections'"
                      [trackDelay]="'true'"
                      [trackType]="'o'"
                      [prop10]="'dealer:button:print directions'">
                <span [translate]="'locateDealer_directions_printDirectionsBtn'"></span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <div class="dealer-map-canvas gray-stroke js-dealer-map-canvas"></div>
      </div>
    </div>
</div>
  